import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { TalentPoolsByCompanyHttpService } from './talent-pools-by-company-http.service';
import { TalentPoolsByCompanyActions } from './talent-pools-by-company.store';

@Injectable({
  providedIn: 'root',
})
export class TalentPoolsByCompanyEffects {
  public effects = createEffectFactory(TalentPoolsByCompanyActions, this.actions$);

  public fetch = this.effects(TalentPoolsByCompanyActions.fetchOne, ({ payload }) =>
    this.http.fetchOne$(<string>payload.id).pipe(
      map(response => ({
        data: response,
        id: response.id,
      })),
    ),
  );

  constructor(
    private http: TalentPoolsByCompanyHttpService,
    private store: Store,
    private actions$: Actions,
  ) {}
}
